<script setup lang="ts">
// Pills de filtro do Minha Conta V2 (ENG-362): Todos/Cassino/Esporte etc.
// Ativa = gradiente do v2-primary com borda (mesmo estilo das tabs do Shell).
interface FilterTab {
  key: string;
  label: string;
}

interface Props {
  tabs: FilterTab[];
}

const props = defineProps<Props>();

const active = defineModel<string>({ required: true });
</script>

<template>
  <div class="filter-tabs flex w-full items-center gap-[6px] overflow-x-auto">
    <button
      v-for="tab in props.tabs"
      :key="tab.key"
      class="flex h-[32px] shrink-0 items-center justify-center whitespace-nowrap text-[12px] leading-[16px]"
      :class="
        active === tab.key
          ? 'rounded-[14px] border border-v2-primary bg-gradient-to-r from-v2-primary/70 to-v2-primary/20 px-[14px] text-v2-primary-foreground'
          : 'rounded-[12px] bg-v2-default px-[12px] text-v2-default-foreground'
      "
      type="button"
      @click="active = tab.key"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<style scoped lang="scss">
.filter-tabs {
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
